import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';

import { GetUrl, FetchConfig } from "../helpers/ConfigApi";
import { useInterval } from "../hooks/useInterval";

import Container from '@material-ui/core/Container';

import Banner from '../components/layout/Banner';
import Content from '../components/content/Content';
import Footer from '../components/layout/Footer';
import Loading from "./Loading";

export default () => {

  const { id } = useParams();

  const [isInitialising, setIsInitialising] = useState(true);
  const [message, setMessage] = useState("Loading ... ");
  const [url, setUrl] = useState(GetUrl(id));
  const [config, setConfig] = useState();

  useEffect(() => {
    FetchConfig(url).then((newConfig) => {
      if (newConfig) {
        console.log(newConfig);
        setConfig(newConfig);
        setIsInitialising(false);
      }
    }).catch(e => { console.log(e); setMessage(e); });
  }, [url]);

  useInterval(() => {
    setUrl(GetUrl(id));
  }, 60000);  

  return (
    <div className="container-event">
      {isInitialising && (
        <Loading message={message} />
      )}
      {!isInitialising && (
        <>
          <Banner config={config} />
          <div className="body-content">
            <Container>
              <div className="body-container">
                <Content config={config} />
              </div>
            </Container>
            <Footer />
          </div>
        </>
      )}
    </div>
  );
};
